import axios from 'axios';
import { SYSTEMDOX_API_URL } from '@/lib/apiConfig';

const api = axios.create({ baseURL: SYSTEMDOX_API_URL });

export interface ScanRuleResult {
  ruleId: string;
  ruleName: string;
  category: string;
  severity: string;
  passed: boolean;
  message: string;
  remediation: string;
  filePath: string;
  autoFixable: boolean;
}

export interface ScanResult {
  repo: string;
  score: number;
  passed: number;
  failed: number;
  total: number;
  results: ScanRuleResult[];
}

export interface ComplianceRule {
  id: string;
  name: string;
  description: string;
  severity: string;
  category: string;
}

export const scannerApi = {
  setAuthProvider(getToken: () => Promise<string | null>) {
    api.interceptors.request.use(async (config) => {
      const token = await getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  },

  async listRules(): Promise<ComplianceRule[]> {
    const { data } = await api.get('/scanner/rules');
    return data;
  },

  async scanRepo(repo: string): Promise<ScanResult> {
    const { data } = await api.post('/scanner/scan', { repo });
    return data;
  },
};
